/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Views.FriendLandingPage = class FriendLandingPage {
  constructor(el, controller) {
    this.onFieldChange = this.onFieldChange.bind(this);
    this.showPostPurchaseTrackingInstructions = this.showPostPurchaseTrackingInstructions.bind(this);
    this.toggleTick = this.toggleTick.bind(this);
    this.displayCustomFieldTick = this.displayCustomFieldTick.bind(this);
    this.postPurchaseTrackingEnabled = this.postPurchaseTrackingEnabled.bind(this);
    this.postPurchaseTrackingEnabledAndCustomFieldEmpty = this.postPurchaseTrackingEnabledAndCustomFieldEmpty.bind(this);
    this.emailValid = this.emailValid.bind(this);
    this.fullNameValid = this.fullNameValid.bind(this);
    this.firstNameValid = this.firstNameValid.bind(this);
    this.lastNameValid = this.lastNameValid.bind(this);
    this.customFieldValid = this.customFieldValid.bind(this);
    this.termsOptInValid = this.termsOptInValid.bind(this);
    this.marketingOptInValid = this.marketingOptInValid.bind(this);
    this.disableButton = this.disableButton.bind(this);
    this.enableButton = this.enableButton.bind(this);
    this.disableInputs = this.disableInputs.bind(this);
    this.enableInputs = this.enableInputs.bind(this);
    this.enableCustomField = this.enableCustomField.bind(this);
    this._formSubmitted = this._formSubmitted.bind(this);
    this.el = el;
    this.controller = controller;
    this.el.on('submit', this._formSubmitted);
    this.submitButton = this.el.find('[data-button]');
    this.clipboardButton = this.el.find('[data-clipboard-button]');
    this.showingContinueButton = false;
    this.revealVoucher = this.el.data('reveal-voucher-code');
    this.incentiveReveal = this.el.find('[data-incentive-reveal]');
    this.voucherContainer = this.el.find('[data-voucher-container]');
    this.autoSubmitButton = this.submitButton.data('auto-submit');
    this.postPurchaseTrackingInstructions = this.el.find("[data-post-purchase-tracking-instructions]");
    this.autoContinueToClientSite = this.submitButton.data('auto-continue-to-client-site');
    this.autoContinueToFriendConfirmationPage = this.submitButton.data('auto-continue-to-friend-confirmation-page');
    this.autoContinueToFriendConfirmationPageWithVoucher = this.submitButton.data('auto-continue-to-friend-confirmation-page-with-voucher');
    this.autoSubmitButtonCta = this.el.find('[data-auto-submit-cta]');

    this.fullName = this.el.find('[data-input-tick="full_name"]');
    this.firstName = this.el.find('[data-input-tick="first_name"]');
    this.lastName = this.el.find('[data-input-tick="last_name"]');
    this.email = this.el.find('[data-input-tick="email"]');
    this.customField = this.el.find('[data-input-tick="custom-field"]');
    this.termsOptIn = this.el.find('[data-input-opt-in="terms"]');
    this.marketingOptIn = this.el.find('[data-input-opt-in="marketing"]');
    this.marketingOptInOptional = this.marketingOptIn.data('optional');

    this.termsOptInCheckbox = this.termsOptIn.find('input:checkbox');
    this.marketingOptInCheckbox = this.marketingOptIn.find('input:checkbox');
  }

  onFieldChange(cb) {
    this.email.on('input', 'input', cb);
    this.fullName.on('input', 'input', cb);
    this.firstName.on('input', 'input', cb);
    this.lastName.on('input', 'input', cb);
    this.customField.on('input', 'input', cb);
    this.customField.on('change', 'input', cb);
    this.termsOptIn.on('change', cb);
    return this.marketingOptIn.on('change', cb);
  }

  showResult(voucherResult) {
    this.showingContinueButton = true;
    return this.submitButton.fadeOut('fast', () => {
      this._setupMessageAndInstructions(voucherResult);
      this.voucherContainer.empty();
      const primaryCallback = this._setupVoucher(voucherResult.primary);
      const secondaryCallback = this._setupVoucher(voucherResult.secondary);

      return this.incentiveReveal.fadeIn('fast', () => {
        if (primaryCallback != null) { primaryCallback(); }
        if (secondaryCallback != null) { return secondaryCallback(); }
      });
    });
  }

  showPostPurchaseTrackingInstructions() {
    return this.postPurchaseTrackingInstructions.fadeIn('fast');
  }

  _setupMessageAndInstructions(voucherResult) {
    this.el.find('[data-voucher-message]').toggle(voucherResult.message != null).html(voucherResult.message);
    return this.el.find('[data-voucher-instructions]').toggle((voucherResult.message == null));
  }

  _setupVoucher(voucher) {
    if (voucher == null) { return; }

    const $el = this._buildTemplate(voucher.display_type);

    const setupCallback = (() => {
      if (voucher.display_type === 'text') {
      return this._setupTextVoucher($el, voucher);
    } else if (voucher.display_type === 'barcode') {
      return this._setupBarcodeVoucher($el, voucher);
    }
    })();

    this.voucherContainer.append($el);
    return setupCallback;
  }

  _setupTextVoucher($el, voucher) {
    $el.find('[data-box]').val(voucher.code);
    const $clipboardButton = $el.find('[data-clipboard-button]');
    $clipboardButton.attr('data-clipboard-text', voucher.code);

    return () => new Buyapowa.Views.ClipboardButton($clipboardButton);
  }

  _setupBarcodeVoucher($el, voucher) {
    $el.find('.barcode-voucher').addClass(voucher.display_subtype);
    const $img = $el.find('img[data-barcode]');
    const barcodeUrl = $img.data('barcode-url');

    $img.attr('src', barcodeUrl + `/${encodeURIComponent(voucher.display_subtype)}/?data=${encodeURIComponent(voucher.code)}`);

    return () => null;
  }

  _buildTemplate(displayType) {
    const $el = this.el.find(`[data-voucher-template-display-type='${displayType}']`).clone();
    $el.removeAttr('style').removeAttr('data-voucher-template-display-type');
    return $el;
  }

  toggleTick() {
    if (this.email.size() > 0) {
      this.email.toggleClass('tick', this.emailValid());
    }

    if (this.fullName.size() > 0) {
      this.fullName.toggleClass('tick', this.fullNameValid());
    }

    if (this.firstName.size() > 0) {
      this.firstName.toggleClass('tick', this.firstNameValid());
    }

    if (this.lastName.size() > 0) {
      this.lastName.toggleClass('tick', this.lastNameValid());
    }

    if (this.customField.size() > 0) {
      return this.customField.toggleClass('tick', this.displayCustomFieldTick());
    }
  }

  displayCustomFieldTick() {
    if (this.customField.length === 0) { return true; }
    return new Buyapowa.Helpers.CustomSignupFieldValidator(this.customField.find('input')).isValid();
  }

  postPurchaseTrackingEnabled() {
    return this.submitButton.data("post-purchase-tracking") === true;
  }

  postPurchaseTrackingEnabledAndCustomFieldEmpty() {
    return this.postPurchaseTrackingEnabled() && (this.customField.find('input').val().length === 0);
  }

  emailValid() {
    return new Buyapowa.Helpers.EmailValidator(this.email.find('input').val()).isValid();
  }

  fullNameValid() {
    const input = this.fullName.find('input');
    if (input.length === 0) { return true; }

    const validatorClass = (this.fullName.data().strictNaming != null) ?
      Buyapowa.Helpers.StrictFullNameValidator
    :
      Buyapowa.Helpers.FullNameValidator;

    return new validatorClass(input.val(), this.fullName.data().minLength).isValid();
  }

  firstNameValid() {
    const input = this.firstName.find('input');
    if (input.length === 0) { return true; }
    return new Buyapowa.Helpers.PartialNameValidator(input.val(), this.firstName.data().minLength).isValid();
  }

  lastNameValid() {
    const input = this.lastName.find('input');
    if (input.length === 0) { return true; }
    return new Buyapowa.Helpers.PartialNameValidator(input.val(), this.lastName.data().minLength).isValid();
  }

  customFieldValid() {
    if (this.customField.length === 0) { return true; }
    const valid = new Buyapowa.Helpers.CustomSignupFieldValidator(this.customField.find('input')).isValid();

    if (valid) {
      return true;
    } else if (!valid && this.postPurchaseTrackingEnabledAndCustomFieldEmpty()) {
      return true;
    } else {
      return false;
    }
  }

  termsOptInValid() {
    if (this.termsOptIn.length === 0) { return true; }
    return this.termsOptInCheckbox.is(':checked');
  }

  marketingOptInValid() {
    if (this.marketingOptInOptional) { return true; }
    if (this.marketingOptIn.length === 0) { return true; }
    return this.marketingOptInCheckbox.is(':checked');
  }

  disableButton() {
    return this.submitButton.attr('disabled','disabled');
  }

  enableButton() {
    return this.submitButton.removeAttr('disabled');
  }

  disableInputs() {
    this.fullName.find('input').attr('disabled', 'disabled');
    this.firstName.find('input').attr('disabled', 'disabled');
    this.lastName.find('input').attr('disabled', 'disabled');
    this.email.find('input').attr('disabled', 'disabled');
    this.customField.find('input').attr('disabled', 'disabled');
    this.termsOptInCheckbox.attr('disabled', 'disabled');
    return this.marketingOptInCheckbox.attr('disabled', 'disabled');
  }

  enableInputs() {
    this.fullName.find('input').removeAttr('disabled');
    this.firstName.find('input').removeAttr('disabled');
    this.lastName.find('input').removeAttr('disabled');
    this.email.find('input').removeAttr('disabled');
    this.customField.find('input').removeAttr('disabled');
    this.termsOptInCheckbox.removeAttr('disabled');
    return this.marketingOptInCheckbox.removeAttr('disabled');
  }

  enableCustomField() {
    return this.customField.find("input").removeAttr('disabled');
  }

  setButtonText(text) {
    const oldText = this.submitButton.text();
    this.submitButton.text(text);
    return oldText;
  }

  getUrl() {
    return this.el.attr('action');
  }

  getData() {
    return this.el.serializeObject();
  }

  shouldAutoSubmit() {
    return this.autoSubmitButton;
  }

  redirectToClientSite() {
    return window.open(this.autoSubmitButtonCta.attr('href'),'_parent');
  }

  redirectToFriendConfirmationPage() {
    return window.open(this.autoSubmitButtonCta.attr('href'),'_self');
  }

  codeProgressText() {
    return this.el.data('code-progress-text');
  }

  doneText() {
    return this.el.data('done-text');
  }

  almostDoneText() {
    return this.el.data('almost-done-text');
  }

  failureText() {
    return this.el.data('failure-text');
  }

  _formSubmitted(e) {
    this.disableButton();
    if (!this.showingContinueButton) {
      if (this.revealVoucher) {
        this.controller.revealVoucher();
      } else {
        this.controller.revealContinueButton();
      }
    }

    e.preventDefault();
    return false;
  }
};
